// import { headerVisible } from "../include/module";
import { headerToggle } from "../include/module";
import { newsTile } from "../include/module";
import { artistTile } from "../include/module";
import { anchorLink } from "../include/module";





(() => {

  // ------------------------------------------------------------------------
  // headerVisible
  // -> SP ヘッダー出現
  // ------------------------------------------------------------------------
  // headerVisible();

  // ------------------------------------------------------------------------
  // headerToggle
  // -> SP ヘッダー開閉
  // ------------------------------------------------------------------------
  headerToggle();

  // ------------------------------------------------------------------------
  // newsTile
  // -> NEWSタイトル 高さ調整
  // ------------------------------------------------------------------------
  newsTile();

  // ------------------------------------------------------------------------
  // artistTile
  // -> ARTIST名前 高さ調整
  // ------------------------------------------------------------------------
  artistTile();

  // ------------------------------------------------------------------------
  // anchorLink
  // -> リンク
  // ------------------------------------------------------------------------
  anchorLink();



  // ------------------------------------------------------------------------
  // gc
  // -> GoogleCalendar
  // ------------------------------------------------------------------------
  $('#js-Calendar').fullCalendar({
      header: {
        left: 'prev,next today',
        center: 'title',
        right: 'month,listYear'
      },
      displayEventTime: true,
      googleCalendarApiKey: 'AIzaSyCqxPphPvXMaqVGcDvY91qBV0C-QGc9OgI',
      events: 'straycatsrecords@gmail.com',
      eventClick: function(event) {
        // opens events in a popup window
        window.open(event.url, 'gcalevent', 'width=700,height=600');
        return false;
      },
      loading: function(bool) {
        $('#loading').toggle(bool);
      }
    });


})();



// WEBPACK FOOTER //
// script.js